import { useCallback, useState } from 'react';
import type { Role } from '@planning-session/shared';
import { retroPath, roomPath, useRoute } from './lib/router.js';
import type { SessionCredentials } from './lib/useSession.js';
import { JoinGate } from './components/JoinGate.js';
import { Landing } from './components/Landing.js';
import { Room } from './components/Room.js';
import { RetroRoom } from './components/retro/RetroRoom.js';

export function App() {
  const { route, navigate } = useRoute();
  const [credentials, setCredentials] = useState<SessionCredentials | null>(null);

  const enterRoom = useCallback(
    (roomId: string, name: string, role: Role) => {
      setCredentials({ roomId, name, role });
      navigate(roomPath(roomId));
    },
    [navigate],
  );

  const enterRetro = useCallback(
    (roomId: string, name: string, role: Role) => {
      setCredentials({ roomId, name, role });
      navigate(retroPath(roomId));
    },
    [navigate],
  );

  const exitRoom = useCallback(() => {
    setCredentials(null);
    navigate('/');
  }, [navigate]);

  if (route.name === 'landing') {
    return <Landing onEnter={enterRoom} onEnterRetro={enterRetro} />;
  }

  // A shared link lands here without credentials: ask who is arriving first.
  if (!credentials || credentials.roomId !== route.roomId) {
    return (
      <JoinGate
        roomId={route.roomId}
        onJoin={(name, role) => (route.name === 'retro' ? enterRetro(route.roomId, name, role) : enterRoom(route.roomId, name, role))}
        onBack={exitRoom}
      />
    );
  }

  if (route.name === 'retro') {
    return <RetroRoom credentials={credentials} onExit={exitRoom} />;
  }

  return <Room credentials={credentials} onExit={exitRoom} />;
}
